export const DATA_CACHE_SIZE = 'DataCache.Size';
export const DATA_CACHE_LOCATION = 'DataCache.Location';
export const MOUNT_POINT_WINDOWS = 'FileSystem.MountPointWindows';
export const MOUNT_POINT_OSX = 'FileSystem.MountPointOSX';
export const MOUNT_POINT_LINUX = 'FileSystem.MountPointLinux';
export const FILE_LOCKING_EXTENSIONS = 'FileSystem.LockingExtensions';
export const FORBID_SPECIAL_CHARACTERS = 'FileSystem.ForbidSpecialCharacters';
export const MAX_DOWNLOAD_RATE = 'ObjectScheduler.MaxDownloadRate';
export const MAX_UPLOAD_RATE = 'ObjectScheduler.MaxUploadRate';
export const TEAM_CACHE_ENABLED = 'TeamCache.Enabled';
export const TEAM_CACHE_LOCATION = 'TeamCache.Location';
export const EXTERNAL_FILES_ENABLED = 'FileSystem.ExternalFilesEnabled';
export const SETTINGS_NAMES = [
    DATA_CACHE_SIZE,
    DATA_CACHE_LOCATION,
    MOUNT_POINT_WINDOWS,
    MOUNT_POINT_OSX,
    MOUNT_POINT_LINUX,
    FILE_LOCKING_EXTENSIONS,
    FORBID_SPECIAL_CHARACTERS,
    MAX_DOWNLOAD_RATE,
    MAX_UPLOAD_RATE,
    TEAM_CACHE_ENABLED,
    TEAM_CACHE_LOCATION,
    EXTERNAL_FILES_ENABLED,
];
